import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.882 21.441a2.5 2.5 0 0 0 2.236 0l7.776-3.888A2 2 0 0 0 22 15.763V8.546a2.5 2.5 0 0 0-1.382-2.236l-7.724-3.862a2 2 0 0 0-1.788 0L3.382 6.31A2.5 2.5 0 0 0 2 8.545v7.219a2 2 0 0 0 1.106 1.789zm-6.83-5.092a1 1 0 0 1-.552-.894V8.993a.25.25 0 0 1 .362-.224l6.835 3.418a1 1 0 0 1 .553.895v6.461a.25.25 0 0 1-.362.224zm.91-9.153a.25.25 0 0 0 0 .447l6.59 3.295a1 1 0 0 0 .895 0l6.59-3.295a.25.25 0 0 0 0-.447L12.447 3.9a1 1 0 0 0-.894 0zm15.176 1.573a.25.25 0 0 1 .362.224v6.462a1 1 0 0 1-.553.894l-6.835 3.418a.25.25 0 0 1-.362-.224v-6.461a1 1 0 0 1 .553-.895z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBox24);
